export default "__VITE_ASSET__DQW71lu3__"